module.exports = __webpack_public_path__ + "static/strength-carousel-05db1d176a685f7c62775bf945633dc9.svg";